<div class="assistant-banner-content-links-container">
  <ng-container *ngFor="let link of links">
    <span
      class="link"
      [innerHTML]="link"
    ></span>
  </ng-container>
  <a
    class="link help-link"
    (click)="onHelp()"
    merriNoFocusLink
  >
    Help
  </a>
</div>
